export const isCsvFile = (file: File): boolean =>
  file.name.toLowerCase().endsWith('.csv');
